import React, { Component } from 'react';
import { connect } from 'react-redux';
//import ReactDom from 'react-dom';
import Notification from 'react-web-notification/lib/components/Notification';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
//import NewWindow from 'react-new-window'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

import unreadActions from '../actions/unread_message_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';

import '../../src/index.css';

//message notification example
//https://github.com/mobilusoss/react-web-notification/blob/develop/example/app.js
//https://developer.mozilla.org/en-US/docs/Web/API/notification

//allow react dev tools work
window.React = React;

export class MemberListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            hub: {},
            chatBoxOpen: false,
            features: {
                width: 450,
                height: 450,
                left: 450,
                top: 450
            },
            //showWindowPortal: false,
            showFullProfile: false,
            unreadMessages: {},
            ignore: true,
            title: '',
        };
    }

    componentDidMount() {
        document.addEventListener('contextmenu', event => event.preventDefault()); // Disables Chrome's right click menu
        setTimeout(function () {
            if (localStorage.getItem("token") !== null) {
                this.props.hub.on('NewMessage', (message => {
                    setTimeout(function () {
                        if (message.payload.userId === this.props.member.id) {
                            this.forceUpdate();
                        }
                    }.bind(this), 1000);
                }))
            }
        }.bind(this), 5000);
        setInterval(function () {
            //this.props.setWindowAutoClose(false);
            this.forceUpdate();
            //this.props.setWindowAutoClose(true);
        }.bind(this), 3000);
    }

    onMouseEnter = (e) => {
        this.setState({ hovered: true });
    };

    onMouseLeave = (e) => {
        this.setState({ hovered: false });
    };

    //showChatBox = () => {
    //  this.setState({ showWindowPortal: !this.state.showWindowPortal });
    //};

    openChatBox = () => {
        this.disableUnread();
        if (this.state.chatBoxOpen) {
            this.setState({ chatBoxOpen: false }, () => this.setState({ chatBoxOpen: true }));
        } else {
            this.setState({ chatBoxOpen: true });
        }
    };

    closeChatBox = () => {
        this.setState({ chatBoxOpen: false });
    };

    handleTabsDoubleClick = () => {
        console.log("this.props.member: ", this.props.member);
        this.disableUnread();
        this.props.callbackFromParent(this.props.member, true, true, false);
        console.log("addNewRecipient was called from MemberListItem");
    };

    //closeWindowPortal = () => {
    //  this.setState({ showWindowPortal: false });
    //};

    showProfile = () => {
        this.setState({ showFullProfile: true });
    };

    handleCloseFullProfile = () => {
        this.setState({ showFullProfile: false });
    };

    flashNotification = (protocol, action, params) => {
        localStorage.setItem("justLoggedIn", true);
        console.log("[MemberListItem.js] flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams !== "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };

    disableUnread = () => {
        console.log("disableUnread from MemberListItem");
        this.props.updateRead(this.props.member.id);
        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            //this.props.updateLastSeen();
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
            console.log("Don't update since the user isn't logged in");
        }
        //this.flashNotification('teamx', 'flashstop'); // breaks window focus when double clicking name from member list
        //this.props.setIconFlash(false);
        //setTimeout(function () {
        //  this.forceUpdate();
        //}.bind(this), 1000);
    };

    //message notification handlers
    handlePermissionGranted = () => {
        console.log('Permission Granted');
        this.setState({
            ignore: false
        });
    };

    handlePermissionDenied = () => {
        console.log('Permission Denied');
        this.setState({
            ignore: true
        });
    };

    handleNotSupported = () => {
        console.log('Web Notification not Supported');
        this.setState({
            ignore: true
        });
    };

    handleNotificationOnClick = (e, tag) => {
        console.log(e, 'Notification clicked tag:' + tag);
    };

    handleNotificationOnError = (e, tag) => {
        console.log(e, 'Notification error tag:' + tag);
    };

    handleNotificationOnClose = (e, tag) => {
        console.log(e, 'Notification closed tag:' + tag);
    };

    handleNotificationOnShow = (e, tag) => {
        console.log("Play sound called...");
        this.playSound();
        console.log(e, 'Notification shown tag:' + tag);
    };

    playSound = (filename) => {
        console.log("Inside play sound...");
        document.getElementById('sound').play();
    };

    handleButtonClick = () => {
        if (this.state.ignore) {
            return;
        }
        const now = Date.now();
        //const title = 'React-Web-Notification' + now;
        //const body = 'Hello' + new Date();
        const title = 'Blank sent you a message';
        const body = 'Message preview...';
        const tag = now;
        const icon = 'http://mobilusoss.github.io/react-web-notification/example/Notifications_button_24.png'; //teamx icon?
        // const icon = 'http://localhost:3000/Notifications_button_24.png';

        // Available options
        // See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
        const options = {
            tag: tag,
            body: body,
            icon: icon,
            lang: 'en',
            dir: 'ltr',
            sound: './light.mp3'  // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
        };
        this.setState({
            title: title,
            options: options
        });
    };

    render() {
        const { hovered } = this.state;
        const { chatBoxOpen } = this.state;
        const style = hovered ? { backgroundColor: "#ebebeb" } : {};

        const memberStatus = this.props.member.status;
        const memberInOffice = this.props.member.inOffice;
        const awayMessage = this.props.member.awayMessage;
        const awayTime = this.props.member.awayTime;
        //const onCall = this.props.member.onCall;

        let statusIcon;
        let memberName;
        let memberExtension;
        let awayMessageShow;
        let fullProfile;
        let lastName;
        let unreadIcon;
        let notification;

        //if (memberStatus === "inAvailable") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">check_circle</i>;
        //} else if (memberStatus === "inBusy") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">access_time</i>;
        //} else if (memberStatus === "outBusy") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">remove_circle_outline</i>;
        //} else if (memberStatus === "outDone") {
        //  memberStatusIcon = <i className="material-icons" fontSize="small">highlight_off</i>;
        //}

        // If member is in office and available.
        //if (memberStatus === "inAvailable") {
        if (memberInOffice === true && memberStatus === "Available") {
            memberName = <b style={{ color: '#0051d3', 'cursor': 'default' }}>{this.props.member.username}</b>;
            memberExtension = <b style={{ color: '#0051d3', 'cursor': 'default' }}>{this.props.member.extension}</b>;
        }

        // If member is in office and busy or is done for the day or they have disconnected.
        else if ((memberInOffice === true && memberStatus === "Busy") || (memberInOffice === false && memberStatus === "Done") || (memberInOffice === false && memberStatus === "Disconnected")) {
            memberName = this.props.member.username;
            memberExtension = this.props.member.extension;
        }

        // If member is out of office and will be back.
        else if (memberInOffice === false && memberStatus === "Busy") {
            memberName = <b>{this.props.member.username}</b>; ////////////////////////////////////////////////////
            memberExtension = <b>{this.props.member.extension}</b>;
        }

        // If member is busy and has entered an away message, show clock icon and their away message.
        if (awayMessage !== null && awayMessage !== "") {
            statusIcon =
                <Tooltip
                    placement="top-end"
                    title={
                        <React.Fragment>
                            <h6>
                                Away Message
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" fontSize="small" style={{ transform: 'scale(1.2)', fontSize: '14px', marginTop: '2px', color: 'black', 'cursor': 'default', paddingRight: '48px' }}>
                        access_time
          </i>
                </Tooltip>;
            awayMessageShow = <div><br /><b>Away Message: </b><br />{awayMessage} - back by {awayTime}</div>;
        }

        // TODO: warning icon displays next to disconnected person
        // If member is disconnected, their away message gets reset if they had one and show warning icon.
        if (memberInOffice === false && memberStatus === "Disconnected") {
            statusIcon =
                <Tooltip
                    placement="top-end"
                    title={
                        <React.Fragment>
                            <h6>
                                Disconnected
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" fontSize="small" style={{ transform: 'scale(1.2)', fontSize: '14px', paddingTop: '2px', color: 'black', 'cursor': 'default', paddingRight: '48px' }}>
                        warning
          </i>
                </Tooltip >;
        }

        // If there is an unread message
        if (this.props.unreadMessages[this.props.member.id]) {
            //unreadIcon = <b style={{ transform: 'scale(1.2)', fontSize: '14px', paddingTop: '3px', color: '#d80000' }}><img src={marketMapsLogo} alt="logo" /></b>;
            unreadIcon = <b style={{ color: '#0051d3', 'cursor': 'default' }}><i style={{ transform: 'scale(1.2)', fontSize: '14px', marginTop: '3px', marginLeft: '5px', 'cursor': 'default' }} className="material-icons" fontSize="small">chat</i></b>;
            /*memberName = <b style={{ color: '#0051d3' }}>{this.props.member.firstName}</b>;
            memberExtension = <b style={{ color: '#0051d3' }}>{this.props.member.extension}</b>;*/

            notification =
                <div>
                    <button onClick={this.handleButtonClick}>Notif!</button>
                    <Notification
                        ignore={this.state.ignore && this.state.title !== ''}
                        notSupported={this.handleNotSupported}
                        onPermissionGranted={this.handlePermissionGranted}
                        onPermissionDenied={this.handlePermissionDenied}
                        onShow={this.handleNotificationOnShow}
                        onClick={this.handleNotificationOnClick}
                        onClose={this.handleNotificationOnClose}
                        onError={this.handleNotificationOnError}
                        //timeout={5000} // milli sec to close notification automatically. Ignored if 0 or less. (Default 5000)
                        //disableActiveWindow={true} //if true, nothing will be happen when window is active
                        title={this.state.title}
                    options={this.state.options}
                /><audio id='sound' ref="audio_tag" src="./light.mp3" preload='auto' />
                    {//
        //  <audio id='sound' preload='auto'>

        //    <source src='./light.mp3' type='audio/mpeg' />
        //    <source src='./light.ogg' type='audio/ogg' />
        //    <embed hidden={true} autostart='false' loop={false} src='./light.mp3' />
        //  </audio>
        }
                </div>;
        } else {
            unreadIcon = <div></div>;
        }

        if (this.props.member.lastName === null) {
            lastName = "";
        }

        if (this.state.showFullProfile === true) {
            fullProfile =
                <Dialog
                    open={this.state.showFullProfile}
                    onClose={this.handleCloseFullProfile}
                    aria-labelledby="alert-dialog-title"
                    PaperProps={{ style: { minWidth: '195px' } }}
                >
                    <Typography id="alert-dialog-title" style={{ padding: '10px', fontWeight: '600', fontSize: '18px' }}>{this.props.member.username}'s Profile</Typography>
                    <DialogContent style={{ paddingTop: '0px', paddingRight: '5px', paddingBottom: '0px', paddingLeft: '5px', fontSize: '11px' }}>
                        <b>Name: </b>{this.props.member.firstName} {this.props.member.lastName ? this.props.member.lastName : ""}<br />
                        <b>Address: </b>{this.props.member.address}, {this.props.member.city}, {this.props.member.state}, {this.props.member.zipCode}<br />
                        <b>Work: </b>{this.props.member.workPhone}<br />
                        <b>Cell: </b>{this.props.member.cellPhone}<br />
                        <b>Home: </b>{this.props.member.homePhone}<br />
                        <b>Email: </b>{this.props.member.email}<br /><br />
                        <b>Monday: </b>{this.props.member.monday}<br />
                        <b>Tuesday: </b>{this.props.member.tuesday}<br />
                        <b>Wednesday: </b>{this.props.member.wednesday}<br />
                        <b>Thursday: </b>{this.props.member.thursday}<br />
                        <b>Friday: </b>{this.props.member.friday}<br />
                        <b>Saturday: </b>{this.props.member.saturday}<br />
                        <b>Sunday: </b>{this.props.member.sunday}<br />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseFullProfile} color="primary">
                            Close
            </Button>
                    </DialogActions>
                </Dialog>;
        }

        return (
            <div>
                <Tooltip
                    enterDelay={500}
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h4>
                                <b style={{ color: '#ffffff' }}>
                                    {this.props.member.firstName + " "}{this.props.member.lastName ? this.props.member.lastName : ""}
                                </b>
                            </h4>
                            <h6>
                                <b>Work: </b>{this.props.member.workPhone}<br />
                                <b>Cell: </b>{this.props.member.cellPhone}<br />
                                <b>Home: </b>{this.props.member.homePhone}<br />
                                {awayMessageShow}
                            </h6>
                        </React.Fragment>
                    }
                >
                    <div style={{ flexgrow: '1', margin: '0px' }} onDoubleClick={this.handleTabsDoubleClick} onContextMenu={this.showProfile}>
                        <Grid container spacing={0} style={style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                            <Grid style={{ 'cursor': 'default' }} item xs={1}>{unreadIcon}</Grid>
                            <Grid style={{ 'cursor': 'default', paddingLeft: '8px' }} item xs={7}>{memberName}</Grid>
                            <Grid style={{ 'cursor': 'default' }} item xs={3}>{memberExtension}</Grid>
                            <Grid style={{ 'cursor': 'default' }} item xs={1}>{statusIcon}</Grid>
                        </Grid>
                    </div>
                </Tooltip>
                {fullProfile}

                {/*Testing notification
        {notification}*/}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        unreadMessages: state.unreadMessages,
        profile: state.profile,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberListItem);


// WEBPACK FOOTER //
// ./src/components/MemberListItem.js